// src/screens/Merchant/MerchantPromotions.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './MerchantPromotions.css';

import backIcon from '../../assets/backspace-icon.png';
import placeholderPic from '../../assets/placeholder-banner.png';

function MerchantPromotions({ user }) {
  const navigate = useNavigate();
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('pending'); // pending | approved | active

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        console.log('📦 Fetching promotions for:', user.username);
        const res = await api.get(`/sponsorships/by-merchant/${user.username}`);
        console.log('✅ Got promotions:', res.data);
        setPromotions(res.data || []);
      } catch (err) {
        console.error('❌ Failed to fetch promotions:', err);
      } finally {
        setLoading(false);
      }
    };

    if (user?.username) fetchPromotions();
  }, [user]);

  const filteredPromotions = promotions.filter((p) => p.status === filter);

  return (
    <div className="merchant-promotions-container">
      {/* 🔝 Topbar */}
      <div className="merchant-promotions-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="merchant-promotions-back-icon"
          onClick={() => navigate('/merchant/dashboard')}
        />
        <h2>Promotions</h2>
      </div>

      {/* 🧭 Filter Tabs */}
      <div className="promotion-tabs">
        <button
          className={filter === 'pending' ? 'active-tab' : ''}
          onClick={() => setFilter('pending')}
        >
          Pending
        </button>
        <button
          className={filter === 'approved' ? 'active-tab' : ''}
          onClick={() => setFilter('approved')}
        >
          Approved
        </button>
        <button
          className={filter === 'active' ? 'active-tab' : ''}
          onClick={() => setFilter('active')}
        >
          Active
        </button>
      </div>

      {/* 🔽 Scrollable section */}
      <div className="merchant-promotions-scroll">
        {loading ? (
          <p className="promotion-loading">Loading promotions...</p>
        ) : filteredPromotions.length === 0 ? (
          <p className="promotion-empty">No {filter} promotions yet.</p>
        ) : (
          <div className="promotion-grid">
            {filteredPromotions.map((item, i) => (
              <div key={i} className="promotion-card">
                <img
                  src={item.productMedia?.[0] || placeholderPic}
                  alt="Product"
                  className="promotion-image"
                  onClick={() => navigate(`/product/${item.productId}`)}
                />
                <div className="promotion-info">
                  <strong>{item.productName}</strong>
                  <div>Status: {item.status}</div>

                  {/* Only show dates if promotion is active */}
                  {item.status === 'active' ? (
                    <>
                      <div>
                        Start: {new Date(item.startDate).toLocaleDateString()}
                      </div>
                      <div>
                        End: {new Date(item.endDate).toLocaleDateString()}
                      </div>
                    </>
                  ) : null}

                  {/* Only show "Pay Now" button for approved status */}
                  {item.status === 'approved' && (
                    <button
                      className="pay-now-btn"
                      onClick={() => navigate(`/sponsor-payment/${item.productId}`)}
                    >
                      Pay Now
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ➕ Floating Sponsor Button */}
      <div className="sponsor-button-container">
        <button
          className="sponsor-new-btn"

onClick={() => navigate('/select-sponsor')}

        >
          + Sponsor a Product
        </button>
      </div>
    </div>
  );
}

export default MerchantPromotions;
